











import { Vue, Component, Prop } from 'vue-property-decorator'
import type { Coords } from '@russmedia-frontend/nordstern-article'

@Component
export default class MapOverlay extends Vue {
  @Prop({ type: Object, required: true }) readonly coords!: Coords

  public show: boolean = false

  onClose() {
    this.$store.dispatch('modal/hideModal')
    this.$emit('close-modal')
    this.show = false
  }

  mounted() {
    this.$store.dispatch('modal/showModal', {
      showCloseButton: true,
      name: 'map-overlay',
      slotClass: `max-w-xl`,
    })
    this.show = true
  }
}
